import styled from "@emotion/styled";

const ChildK = () => {
  return (
    <Container>
      <Title>아동 안전 표준 정책</Title>
      <Pre>
        {`\n`}
        {`주식회사 핸디랩스(이하 "회사")는 아동의 개인정보 보호와 안전한 서비스 이용을 최우선으로 생각하며, 관련 법령에 따라 만 14세 미만 아동의 개인정보를 보호하기 위한 정책을 시행합니다.\n\n`}
        
        <B>1. 법정대리인 동의 의무</B>
        {`\n회사는 만 14세 미만 아동의 개인정보를 수집할 경우, 반드시 법정 대리인의 동의를 받은 후 수집 및 이용합니다.\n- 동의 방식: 이메일 인증, 휴대폰 인증, 서면 동의 등 적법한 인증 절차 사용\n- 법정 대리인은 언제든지 열람, 수정, 삭제, 처리 정지 등을 요청할 수 있습니다.\n\n`}
        
        <B>2. 서비스 이용 제한 및 보호 조치</B>
        {`\n- 아동에게 부적절할 수 있는 콘텐츠 및 커뮤니티 기능은 기본적으로 제한됩니다.\n- 신고 시스템을 운영하여 유해 콘텐츠 발생 시 빠르게 대응할 수 있도록 합니다.\n\n`}
        
        <B>3. 개인정보 최소 수집 및 목적 외 사용 금지</B>
        {`\n- 회사는 아동 개인정보를 서비스 제공에 필요한 최소한의 범위 내에서만 수집합니다.\n- 수집된 정보는 동의 없이 제3자에게 제공되지 않으며, 다른 용도로 사용되지 않습니다.\n\n`}
        
        <B>4. 개인정보 보호 조치</B>
        {`\n- 아동 개인정보는 일반 회원 정보보다 강화된 보안 정책에 따라 별도로 보호됩니다.\n- 접근 권한 최소화 및 담당자 보안 교육을 통해 내부 유출을 방지합니다.\n\n`}
        
        <B>5. 아동 및 보호자의 권리</B>
        {`\n- 언제든지 개인정보 열람, 수정, 삭제, 동의 철회를 요청할 수 있습니다.\n- 요청 시 지체 없이 조치하며, 그 결과를 법정대리인에게 통지합니다.\n\n`}
        
        <B>6. CSAE와 CSAM 차단</B>
        {`\n- CSAE(아동 성적 학대 및 착취)와 CSAM(아동 성적 학대 콘텐츠)를 자동 필터링할 수 있는 시스템을 상시 가동 중입니다.\n\n`}
        
        <B>7. 아동 및 청소년 보호 책임자・담당자의 지정</B>
        {`\n- 아래와 같이 아동 및 청소년 보호 책임자, 아동 및 청소년 보호 담당자를 지정하여 아동 및 청소년 유해정보 차단과 관리, 아동 및 청소년 유해정보로부터 보호정책을 수립하는 등의 업무를 수행하고 있습니다.\n\n`}
        
        <SubTitle>
          <B>청소년 보호 관리 책임자 및 아동 안전 담당자</B>
        </SubTitle>
        {`\n청소년 보호 관리 책임자 및 아동 안전 담당 : 정승구(CTO, jun@handylabs.io)\n\n`}
        
        <B>8. 정책 고지 및 변경</B>
        {`\n본 정책은 관련 법률 및 회사 방침에 따라 변경될 수 있으며, 변경 시 홈페이지 또는 앱을 통해 공지됩니다.\n\n`}
        
        <SubTitle>
          <B>공고 및 시행 일자</B>
        </SubTitle>
        {`\n아동 안전 표준 정책 공고일자 : 2025년 2월 05일\n아동 안전 표준 정책 시행일자 : 2025년 2월 25일\n`}
      </Pre>
    </Container>
  );
};

const Container = styled.div`
  padding: 20px;
  background-color: #212432;
`;

const Title = styled.div`
  margin: 30px 0;
  color: #fff;
  font-size: 35px;
  font-weight: bold;
  padding-bottom: 35px;
  border-bottom: 1px solid #8b8b8b;
`;

const SubTitle = styled.div`
  text-align: left;
`;

const Pre = styled.pre`
  white-space: pre-wrap; /* Since CSS 2.1 */
  white-space: -moz-pre-wrap; /* Mozilla, since 1999 */
  white-space: -pre-wrap; /* Opera 4-6 */
  white-space: -o-pre-wrap; /* Opera 7 */
  word-wrap: break-word; /* Internet Explorer 5.5+ */
  color: #fff;
  font-family: monospace;
  /* line-height: 1.5; */
  line-height: 25px;
`;

const B = styled.span`
  font-weight: bold;
`;

export default ChildK;